import { useEffect, useRef, type RefObject } from 'react';

export function useClickOutside(
	refs: RefObject<HTMLElement | null> | RefObject<HTMLElement | null>[],
	handler: () => void,
	enabled = true
) {
	const handlerRef = useRef(handler);

	useEffect(() => {
		handlerRef.current = handler;
	}, [handler]);

	useEffect(() => {
		if (!enabled) return;

		const refList = Array.isArray(refs) ? refs : [refs];

		const handleClickOutside = (event: MouseEvent) => {
			const isOutside = refList.every(
				(ref) => ref.current && !ref.current.contains(event.target as Node)
			);
			if (isOutside) handlerRef.current();
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [enabled]);
}
